import React, {Component} from 'react';

import logoImg from "../../images/Logo.png";

import "./index.css"

class Logo extends Component {
    render(){
        return(
            <img src={logoImg} alt="Logo" className="responsive"></img>
        )    
    }
}

export default Logo;


// WEBPACK FOOTER //
// ./src/components/Logo/index.js